var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { IoSearch } from "react-icons/io5";
import useAuth from "../../../hooks/useAuth";
import api from "../../../services/api";
import { Table } from "template/lib";
import styles from "./styles.module.scss";
var Implementation = function (props) {
    var _a;
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(0), totalPages = _c[0], setTotalPages = _c[1];
    var _d = useState([]), items = _d[0], setItems = _d[1];
    var _e = useState(false), refresh = _e[0], setRefresh = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var login = useAuth().login;
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    useEffect(function () {
        if (!props.companyId)
            return;
        setLoading(true);
        api.get("/companies/getProjectImplementation/" + props.companyId, config)
            .then(function (response) {
            var formattedData = response.data.map(function (proj) { return ({
                id: proj.id,
                title: proj.title,
                state: proj.stateName || "—",
                client: proj.cliente
            }); });
            setItems(formattedData);
        }).finally(function () { return setLoading(false); });
    }, [props.companyId, refresh]);
    var lineBtns = [];
    lineBtns.push({
        name: "Detalhes",
        icon: _jsx(IoSearch, { size: 18 }, void 0),
        fn: function (id) {
            window.open("/detailInteration/" + id, "_blank");
        }
    });
    return (_jsx("div", __assign({ className: styles.container }, { children: _jsx(Table, { page: page, setPage: setPage, data: items, totalPAges: totalPages, refresh: setRefresh, loading: loading, title: "Implementa\u00E7\u00F5es de Projeto", lineButton: lineBtns, columns: [
                { label: "ID", key: "id", width: "90px", center: true, eventClick: (_a = lineBtns[0]) === null || _a === void 0 ? void 0 : _a.fn },
                { label: "Título", key: "title" },
                { label: "Status", key: "state" }
            ] }, void 0) }), void 0));
};
export default Implementation;
